import { colorsPalettes } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";
import { Box, Flex, Stack } from "@similarweb/ui-components/foundations";

import { SkeletonLine } from "../SkeletonLine/SkeletonLine";

import { WaterfallCard } from "./WaterfallCard";

type ComingSoonCardProps = {
    readonly rank: number;
};

export const ComingSoonCard = ({ rank }: ComingSoonCardProps) => {
    return (
        <WaterfallCard
            rank={rank}
            opacity={0.55}
            dataAutomation={`contacts-waterfall-card-${rank}`}
            logo={
                <Flex
                    width="32px"
                    height="32px"
                    borderRadius="6px"
                    flexShrink="0"
                    background={colorsPalettes.carbon[50]}
                />
            }
            content={
                <Stack
                    flex="1"
                    minWidth="0"
                    gap="8px"
                >
                    <Flex
                        gap="14px"
                        alignItems="center"
                    >
                        <SkeletonLine width="50%" />
                        <Badge type="coming soon" />
                    </Flex>
                    <SkeletonLine width="80%" />
                </Stack>
            }
            action={
                <Box width="74px">
                    {/* Empty span forces Badge to render without text */}
                    <Badge type="coming soon">
                        <span />
                    </Badge>
                </Box>
            }
        />
    );
};
